import api from 'tim-api';
import { plans as plansEndPoints } from 'endPoints';

export const state = {
    plans: [],
}

export const getters = {
    plans: (state: Object) => state.plans,
};

export const mutations = {
    SET_PLANSLIST(state: Object, plansList: Array<Object>) {
        state.plans = plansList;
    }
};

export const actions = {
    fetchPlansList({ commit }: Action, filter: Object) {
        return api.get(`${plansEndPoints}`, filter).then(({ data }) => {
            commit('SET_PLANSLIST', data.data);
        });

    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}